import { type Location } from 'hb-react/shared/components/DesignSystem/Inputs/InputLocation/types';

interface LocationHiddenInputsProps {
  inputName: string;
  location: Location;
  provider: string;
}

export const LocationHiddenInputs = ({
  inputName,
  location,
  provider,
}: LocationHiddenInputsProps) => (
  <div>
    <input
      type="hidden"
      name={`${inputName}[colloquial_area]`}
      defaultValue={location.colloquial_area || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[neighborhood]`}
      defaultValue={location.neighborhood || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[sublocality_level_1]`}
      defaultValue={location.sublocality_level_1 || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[city]`}
      defaultValue={location.city || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[administrative_area_level_1]`}
      defaultValue={location.administrative_area_level_1 || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[administrative_area_level_2]`}
      defaultValue={location.administrative_area_level_2 || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[country]`}
      defaultValue={location.country || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[lat]`}
      defaultValue={location.lat || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[lng]`}
      defaultValue={location.lng || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[location_level]`}
      defaultValue={location.location_level || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[country_code]`}
      defaultValue={location.country_code || ''}
    />
    <input
      type="hidden"
      name={`${inputName}[postal_code]`}
      defaultValue={location.postal_code || ''}
    />
    {location.bounds && (
      <>
        <input
          type="hidden"
          name={`${inputName}[bounds][][]`}
          defaultValue={location.bounds[0][0]}
        />
        <input
          type="hidden"
          name={`${inputName}[bounds][][]`}
          defaultValue={location.bounds[0][1]}
        />
        <input
          type="hidden"
          name={`${inputName}[bounds][][]`}
          defaultValue={location.bounds[1][0]}
        />
        <input
          type="hidden"
          name={`${inputName}[bounds][][]`}
          defaultValue={location.bounds[1][1]}
        />
      </>
    )}
    {location.lat && (
      <input
        type="hidden"
        name={`${inputName}[provider]`}
        defaultValue={provider}
      />
    )}
  </div>
);
